

export const fontSizes = {
  sm : "xl:text-[12px] lg:text-[12px] md:text-[12px] sm:text-[12px] fl:text-[12px]",
  m: "xl:text-[14px] lg:text-[14px] md:text-[14px] sm:text-[14px] fl:text-[14px]",
  large : "xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[16px] fl:text-[16px]",
  base: "xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] fl:text-[14px]",
  text_xl:
    "xl:text-[20px] lg:text-[20px] md:text-[15px] sm:text-[15px] fl:text-[15px]",
  text_2_xl:
    "xl:text-[24px] lg:text-[22px] md:text-[18px] sm:text-[16px] fl:text-[16px]",
  text_3_xl:
    "xl:text-[28px] lg:text-[26px] md:text-[25px] sm:text-[20px] fl:text-[18px]",
  text_4_xl:
    "xl:text-[40px] lg:text-[35px] md:text-[30px] sm:text-[25px] fl:text-[20px]",
  text_5_xl:
    "xl:text-[45px] lg:text-[37px]  md:text-[30px]   sm:text-[25px]  fl:text-[23px]",
  text_5P5_xl:
    "xl:text-[50px] lg:text-[40px] md:text-[30px] sm:text-[25px] fl:text-[20px]",

  text_6_xl:
    "xl:text-[60px] lg:text-[50px]  md:text-[40px]   sm:text-[30px]  fl:text-[25px]",
  text_7_xl:
    "xl:text-[70px] lg:text-[60px]  md:text-[50px]   sm:text-[40px]  fl:text-[30px]",
  text_8_xl:
    "xl:text-[80px] lg:text-[70px]  md:text-[55px]   sm:text-[40px]  fl:text-[30px]",
  // text_6_xl: 'fl:text-[25px] sm:text-[30px]   md:text-[35px]  lg:text-[45px] xl:text-[55px] ',
   text_9_xl: "xl:text-9xl",
};



export const Constant = {
  CompanyName: "Prime Publishing Authors",
  LegalCompanyName: "Prime Publishing Pro Inc",
  LegalDisclaimer:
    "Powered by Prime Publishing Pro Inc, a US-registered company. Prime Publishing Authors is a trading name of Prime Publishing Pro Inc. Third-party brand names and logos shown on this site are trademarks of their respective owners and are used only to identify distribution channels; they do not imply partnership, affiliation, or endorsement.",
  CompanyUrl: "https://primepublishingauthors.com/",
  // CompanyUrlWithWWW: "https://www.bellevuepublishers.com",
  PhoneNumber: "+1 (713) 379-5697",
  PhoneNumberLink: "tel:+17133795697",
  Email: "info@primepublishingauthors.com",
  EmailLink: "mailto:info@primepublishingauthors.com",
  Address: "17350 STATE HWY 249 STE 220 36619 HOUSTON, TX 77064",
  // TwitterLink: "https://twitter.com/BellevuePublish",
  // TrustPilotLink: "https://www.trustpilot.com/review/nydhub.com",
  WhatsAppLink: "tel:",
  // FacebookLink: "https://www.facebook.com/BellevuePublisher",
  // InstagramLink: "https://www.instagram.com/bellevuepublishers/ ",
  // LinkedinLink: "https://www.linkedin.com/company/bellevue-publishers/",
  // TwitterLink: "https://twitter.com/BellevuePublish",
  // TrustPilotLink: "https://www.trustpilot.com/review/nydhub.com",
  // WhatsAppLink: "tel:8772515759",
  // GoogleReviewsLink: "#",
  // REACT_APP_reCAPTCHA_SITE_KEY: '6LeLj3InAAAAAKu0MpTsQtHhDM2SRjY26CLxPDCG',
  // REACT_APP_reCAPTCHA_SECRET_KEY: '6LeLj3InAAAAAJDHGPz7h1TknZq77KbI9AzY1yq9',
};
